module.exports = __webpack_public_path__ + "files/9dd55d27e6201b197caaedb7bfb5d598.png";